import { render } from "./TacticsAndFormations.vue?vue&type=template&id=be42e9a4&scoped=true"
import script from "./TacticsAndFormations.vue?vue&type=script&lang=js"
export * from "./TacticsAndFormations.vue?vue&type=script&lang=js"

import "./TacticsAndFormations.vue?vue&type=style&index=0&id=be42e9a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be42e9a4"]])

export default __exports__